import React, { useState } from 'react';
import './HarvestView.css';
import PicklistView from './PicklistView';
import UploadView from './UploadView';

interface HarvestViewProps {
  initialFilter?: 'all' | 'due' | 'missing' | 'overdue';
  initialTab?: 'picklist' | 'upload';
  initialUploadFilter?: 'pending' | 'failed';
  onNavigateToUpload?: () => void;
}

const HarvestView: React.FC<HarvestViewProps> = ({ 
  initialFilter = 'due',
  initialTab = 'picklist',
  initialUploadFilter,
  onNavigateToUpload 
}) => {
  const [activeTab, setActiveTab] = useState<'picklist' | 'upload'>(initialTab);

  return (
    <div className="harvest-view">
      <div className="harvest-main-tabs">
        <button 
          className={`harvest-main-tab ${activeTab === 'picklist' ? 'active' : ''}`}
          onClick={() => setActiveTab('picklist')}
        >
          <span className="tab-icon">📋</span>
          Collection Picklist
        </button>
        <button 
          className={`harvest-main-tab ${activeTab === 'upload' ? 'active' : ''}`}
          onClick={() => setActiveTab('upload')}
        >
          <span className="tab-icon">📤</span>
          Upload Invoices
        </button>
      </div>

      <div className="harvest-content">
        {activeTab === 'picklist' ? (
          <PicklistView 
            initialFilter={initialFilter}
            onNavigateToUpload={() => setActiveTab('upload')}
          />
        ) : (
          <UploadView initialFilter={initialUploadFilter} />
        )}
      </div>
    </div>
  );
};

export default HarvestView;